export const LO_PROSPECT_COMP_OPTIONS = Object.freeze([
  { label: 'Par', percent: 0 },
  { label: '1%', percent: 1 },
  { label: '1.5%', percent: 1.5 },
  { label: '2%', percent: 2 },
  { label: '2.5%', percent: 2.5 },
  { label: '3%', percent: 3 },
  { label: '3.5%', percent: 3.5 }
] as const);

export const LO_PROSPECT_COMP_PLAN_PERCENT = Object.freeze(
  Object.fromEntries(
    LO_PROSPECT_COMP_OPTIONS.map(({ label, percent }) => [label, percent])
  ) as Readonly<Record<(typeof LO_PROSPECT_COMP_OPTIONS)[number]['label'], number>>
);

export function loProspectCompLabel(percent: number): string {
  return LO_PROSPECT_COMP_OPTIONS.find((option) => option.percent === percent)?.label
    ?? `${percent}%`;
}
